export class SchemaInfo{
    public id?: string;
      public name?: string;
      public version?: string;
}